import { render, staticRenderFns } from "./WidgetCropRotation.vue?vue&type=template&id=4a289c96&scoped=true&"
import script from "./WidgetCropRotation.vue?vue&type=script&lang=js&"
export * from "./WidgetCropRotation.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCropRotation.vue?vue&type=style&index=0&id=4a289c96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a289c96",
  null
  
)

export default component.exports